<!-- -->
<template>
  <qc-container title="隐私协议">
    <el-form class="mt50"  label-width="10px">
      <el-form-item label="" prop="content">
        <ueditor ref="ueditor"></ueditor>
      </el-form-item>

      <el-form-item class="form-but">
        <el-button type="primary" @click="save()">保存</el-button>
      </el-form-item>
    </el-form>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container";
import Ueditor from "@/components/base/ueditor";

export default {
  name: "userAgreement",
  components: {Ueditor, QcContainer},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {
    save(){
      let content = this.$refs['ueditor'].getContent();
      this.simplePost("/api/mgr/business/text/addOrUpdate",{refId:0,text:content},result=>{
        this.message("保存成功");
      })
    }
  },
  mounted() {
    this.simpleGet("/api/mgr/business/text/detail",{refId:0},result=>{
      this.$refs['ueditor'].init(result.data.text)
    })
  }
}
</script>

<style lang="less" scoped>

</style>
